import { StarIcon } from "@phosphor-icons/react/Star";

// Marks a saved location as a favourite. Sits after the name, both in the
// address book's cards and in the quoting form's location dropdown.
export function LocationsFavouriteMarker() {
  return (
    <StarIcon
      className="ml-2 inline-block h-3.5 w-3.5 text-gold"
      weight="fill"
    />
  );
}
